export function YoutubeFrame(props: { videoId: string }) {
  return (
    <iframe
      width="100%"
      height="315"
      src={`https://www.youtube-nocookie.com/embed/${props.videoId}?autoplay=1`}
      title="YouTube video player"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    ></iframe>
  );
}
